import { render } from "./plates.vue?vue&type=template&id=65fa0dbd"
import script from "./plates.vue?vue&type=script&lang=js"
export * from "./plates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__